import { css, keyframes } from '@emotion/react'

const spin3D = keyframes`
  0% {
    transform: rotate3d(0, 1, 0, 0deg);
  }

  65% {
    transform: rotate3d(1, 1, 1, 390deg);
  }

  80% {
    transform: rotate3d(1, 1, 1, 340deg);
  }

  95% {
    transform: rotate3d(1, 1, 1, 360deg);
  }

  100% {
    transform: rotate3d(0, 1, 0, 360deg);
  }
`

export default css`
  animation: ${spin3D} 3s ease-in-out infinite;
`
